import { useState } from 'react'

export type DeviationServerOrderingField = 'timestamp' | 'milking_unit_num'
export type DeviationOrderingField = DeviationServerOrderingField | 'rowNumber'

type DeviationSortingState = Record<DeviationOrderingField, boolean>

type UseDeviationSortingReturn = {
	sortingState: DeviationSortingState
	ordering: string[] | null
	isRowNumberReversed: boolean
	toggleSort: (field: DeviationOrderingField) => void
}

const SERVER_FIELDS: DeviationServerOrderingField[] = [
	'timestamp',
	'milking_unit_num',
]

const INITIAL_STATE: DeviationSortingState = {
	timestamp: false,
	milking_unit_num: false,
	rowNumber: false,
}

export const useDeviationSorting = (): UseDeviationSortingReturn => {
	const [sortingState, setSortingState] =
		useState<DeviationSortingState>(INITIAL_STATE)

	const toggleSort = (field: DeviationOrderingField) => {
		setSortingState(prev => ({ ...prev, [field]: !prev[field] }))
	}

	const activeServerFields = SERVER_FIELDS.filter(field => sortingState[field])

	const ordering = activeServerFields.length === 0 ? null : activeServerFields

	const isRowNumberReversed = sortingState.rowNumber

	return { sortingState, ordering, isRowNumberReversed, toggleSort }
}
